import { Link } from "react-router-dom";
import { Lock, ArrowUpRight, BookOpen } from "lucide-react";

const GRADE_LABEL = (g) => (g === "K" ? "Kindergarten" : `Grade ${g}`);

export function CourseCard({ course }) {
  const color = course.subject_color || "#3B82F6";
  return (
    <Link
      to={`/course/${course.course_id}`}
      data-testid={`course-card-${course.course_id}`}
      className="group relative flex flex-col justify-between rounded-3xl border-2 border-border bg-card p-6 shadow-sm transition-all duration-200 hover:-translate-y-1.5 hover:shadow-xl"
      style={{ boxShadow: "0 2px 0 rgba(15,23,42,0.06)" }}
    >
      <div className="flex items-start justify-between gap-3">
        <span
          className="flex h-12 w-12 items-center justify-center rounded-2xl"
          style={{ backgroundColor: `${color}22`, color }}
        >
          <BookOpen className="h-6 w-6" strokeWidth={2.5} />
        </span>
        {course.is_premium ? (
          <span className="flex items-center gap-1 rounded-full bg-secondary/15 px-3 py-1 text-[0.65rem] font-black uppercase tracking-wider text-secondary">
            <Lock className="h-3 w-3" strokeWidth={3} /> Premium
          </span>
        ) : (
          <span className="rounded-full bg-muted px-3 py-1 text-[0.65rem] font-black uppercase tracking-wider text-muted-foreground">{GRADE_LABEL(course.grade_level)}</span>
        )}
      </div>

      <span className="mt-5 text-xs font-black uppercase tracking-wider" style={{ color }}>{course.subject_name}</span>
      <h3 className="mt-1 font-head text-xl font-black leading-tight text-foreground group-hover:text-primary">
        {course.title}
      </h3>
      <p className="mt-2 line-clamp-2 text-sm font-semibold text-muted-foreground">{course.description}</p>

      <div className="mt-6 flex items-center justify-between border-t-2 border-border pt-4">
        <span className="text-xs font-black uppercase tracking-wider text-muted-foreground">{GRADE_LABEL(course.grade_level)}</span>
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary transition-transform group-hover:scale-110">
          <ArrowUpRight className="h-5 w-5" strokeWidth={2.75} />
        </span>
      </div>
    </Link>
  );
}
